export function roundAmount(increment, method, precision, amount) {
  const inc = parseFloat(increment);
  const original = parseFloat(amount);
console.log('round off set--',inc, increment, method, precision, amount)
  if (!inc || increment == undefined || method === "NONE") {
      console.log('hiiii33')
    return {
    
      originalAmount: original,
      finalAmount: precision ?  parseFloat(original.toFixed(precision)) : original,
      roundDifference: 0,
      direction: "NONE",
    };
  }

      console.log('hiiii444')

  const factor = 1 / inc;
  let rounded;

  switch (method) {
    case "UPWARD":
      rounded = Math.ceil(original * factor) / factor;
      break;

    case "DOWNWARD":
      rounded = Math.floor(original * factor) / factor;
      break;

    case "NORMAL":
    default:
      rounded = Math.round(original * factor) / factor;
      break;
      
  }

  const finalAmount = rounded.toFixed(precision);
  const roundDifference = 
    (finalAmount - original).toFixed(precision)
  ;

  return {
    originalAmount: original,
    finalAmount,
    roundDifference, // negative if decreased
    direction: method,
  };
}